<template>
  <div id="likeBtn">
    <a
      href="javascript:void(0);"
      class="heart-icon"
      :class="{ 'heart-clicked': isClicked }"
      @click="addLike"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23.297"
        height="21.009"
        viewBox="0 0 23.297 21.009"
      >
        <path
          :class="{ 'like-cls-clicked': isClicked }"
          d="M55.581,990.415c4.5-4.942,10.648-6.911,10.648-12.793s-7.353-8.252-10.648-3.867c-3.3-4.385-10.648-2.013-10.648,3.867S51.082,985.474,55.581,990.415Z"
          transform="translate(-43.933 -970.407)"
          fill="#fff"
          stroke="#9d9d9d"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
      </svg>
    </a>
  </div>
</template>

<script>
import { axios } from "~/libs/vp-api-axios";

export default {
  name: "LikeBtn",
  props: {
    // require は Vue が解釈しないため必須指定として機能していないが、
    // required へ直すと prop 検証が有効になるため本 PR では現状維持とする
    // eslint-disable-next-line vue/require-default-prop
    "articleId": {
      type: Number,
      require: true
    },
  },
  data() {
    return {
      isClicked: false
    };
  },
  mounted() {
    this.setIsClicked();
  },
  methods: {
    addLike() {
      axios.post("/api/article_likes_counts", {
        article_id: this.articleId
      }).then( () => {
        localStorage.setItem(this.articleId + "_user_liked", "on");
        this.isClicked = true;
      }).catch( () => {
        // エラー処理
      });
    },
    setIsClicked () {
      if (localStorage.getItem(this.articleId + "_user_liked") === "on") {
        this.isClicked = true;
      }
    }
  }
};
</script>

<style scoped>
  .heart-clicked {
    pointer-events: none;
  }

  .like-cls-clicked {
    fill: #f92206;
    stroke: #f92206;
  }
</style>
